import { NetworkStatus } from '@apollo/client';
export function mapApolloLoadingStatusToLoadingStatus(networkStatus) {
    switch (networkStatus) {
        case NetworkStatus.loading:
            return 'loading';
        case NetworkStatus.fetchMore:
            return 'fetchMore';
        case NetworkStatus.refetch:
            return 'reloading';
        default:
            return 'none';
    }
}
